import Animate from './animate';
new Animate();